<template>
<div class="octolo-vote-system h-full">
    <button class="ovs-button-start m-auto" v-if="button_start" @click="vote_modal_open_force=true">
        <span class="material-symbols-outlined">how_to_vote</span>
        <span>&nbsp;{{ button_text }}</span>
    </button>
    <template v-if="mode_modal">
        <vote-modal
            :manage
            :readonly
            :meeting
            :group
            :participant
            :resolution
            :only_sign
            :vote_modal_open="propOrForce('vote_modal_open')"
                @close="modal_vote_open=false"
                @vote-modal-close="$emit('vote-modal-close');vote_modal_open_force=false"
                    v-if="propOrForce('vote_modal_open')" />
    </template>
    <component
        :vote_busy="vote_busy"
        :is="VoteSystemToUse(resolution)"
        :readonly="readonly"
        :resolution="resolution"
        :participant="participant.uid"
        :choice_in="choice_in || {vote: ''}"
        :reload_from_choice_in="reload_from_choice_in"
            @vote-change="$emit('vote-change', $event)"
                v-else />
</div>
</template>

<script>
import votesytem from "@/libraries/votesystem/index.js";

export default {
    mixins: [votesytem],
}
</script>
